import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { fetchTenantByDomain, setTokenizeConfig } from "@/redux/slices/tenant";
import { getTokenizeConfig } from "@/service/plans";
import { lockApiTenantId } from "@/service/api";
import fallbackLogo from "@/assets/logo.png";
import ThemeToggle from "@/components/themeToggle";

interface TenantGateProps {
  children: React.ReactNode;
}

export default function TenantGate({ children }: TenantGateProps) {
  const dispatch = useAppDispatch();
  const { loginTenant, loadingByDomain, errorByDomain } = useAppSelector(
    (state) => state.tenant
  );

  useEffect(() => {
    const domain = window.location.hostname?.trim().toLowerCase();
    if (!domain) return;
    dispatch(fetchTenantByDomain(domain));
  }, [dispatch]);

  useEffect(() => {
    if (!loginTenant) return;
    lockApiTenantId(loginTenant.IdTenant);
    getTokenizeConfig()
      .then((config) => dispatch(setTokenizeConfig(config)))
      .catch(() => {
        dispatch(
          setTokenizeConfig({ publicToken: "", isProduction: false })
        );
      });
  }, [dispatch, loginTenant]);

  if (loadingByDomain || (!loginTenant && !errorByDomain)) {
    return (
      <div className="relative flex min-h-[100dvh] w-full items-center justify-center">
        <div className="absolute right-6 top-8">
          <ThemeToggle />
        </div>
        <div className="flex flex-col items-center gap-4">
          <span className="h-10 w-10 rounded-full border-2 border-checkout-hairline border-t-[var(--tenant-accent-color)] animate-spin" />
          <p className="text-sm text-checkout-muted tracking-wide">Carregando…</p>
        </div>
      </div>
    );
  }

  if (errorByDomain || !loginTenant) {
    return (
      <div className="relative flex min-h-[100dvh] w-full flex-col items-center justify-center px-6 text-center">
        <div className="absolute right-6 top-8">
          <ThemeToggle />
        </div>
        <img
          src={fallbackLogo}
          alt=""
          className="mb-8 h-16 w-auto opacity-40"
        />
        <p className="mb-3 text-[11px] uppercase tracking-[0.22em] text-checkout-muted">
          Checkout
        </p>
        <h1 className="font-display text-3xl font-semibold md:text-5xl">
          {errorByDomain || "Barbearia não encontrada"}
        </h1>
        <p className="mt-4 max-w-md text-checkout-muted">
          Este endereço não está vinculado a nenhuma unidade. Confira o link ou
          fale com a barbearia.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
